module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_newyearscard-5922373a9614a747fc66bb38440cb824.jpg";